module.exports = __webpack_public_path__ + "static/cashMobileBox-253fabcacffaaa19224f5cefbd7f571b.png";